import React, { Component } from "react";

class PriceAlertButtonB extends Component {
	render() {
		return (
			<div className="price-alert__button" {...this.props} data-action="price-alert-open">
				Criar alerta <span className="hidden-xs hidden-sm">de preço</span>
				<i className="icon-bell" />
			</div>
		);
	}
}

export default PriceAlertButtonB;
